import React, { useContext, useEffect, useState } from 'react';

import Calendar from 'react-calendar';
import styled from 'styled-components';
import dayjs from 'dayjs';
import Image from 'next/image';
import 'react-calendar/dist/Calendar.css';
import {
  fetchProductAvailabilities,
  updateProductAvailabitoes
} from '../../utils/getProductAvailabilites';
import { useRouter } from 'next/router';
import { PaxContext } from '../../utils/context/checkoutContext';
import { useQuery } from '@apollo/client';
import {
  FETCH_PRODUCT_BOAT,
  FETCH_PRODUCT_BOAT_INTERFACE
} from '../../api/productPage';
import removeDublicates from '../../utils/removeDublicateTimeSlots';
import { useMediaQuery } from '../../hooks/mediaQuery';
import { toast } from 'react-toastify';
import { CurrencySwitcherToggle } from '../../shared-components/CurrencySwitcher/CurrencySwitcherToggle';
type PASSENGERINFO = {
  count: number;
  label: string;
  title: string;
  price: string;
};
type PRIVATEINFO = {
  label: string;
  price: string;
};
export type BoatProductPrice = {
  currency: string;
  prices: Record<string, string>;
  product_id: string;
};

export type AVAILABILITY = {
  id: number;
  startTime: string;
  endTime: string;
  allDay: boolean;
  seats: number;
  seatsAvailable: 150 | number;
  prices: PASSENGERINFO[] | PRIVATEINFO[];
  boatnew_products_prices?: BoatProductPrice[];
};
export type PASSENGERPAX = {
  adults: PASSENGERINFO;
  children?: PASSENGERINFO;
  infants?: PASSENGERINFO;
  seats: number;
};
interface StyledProps {
  modal: boolean;
}
const StyledCelendar = styled(Calendar)<StyledProps>`
  position: absolute;
  z-index: 100;
  width: 100%;

  @media (max-width: 945px) {
    max-width: 100%;
  }
  .react-calendar__month-view__days {
    min-height: 300px;
    height: ${props => (props.modal ? '295px' : '265px')};
    width: 100%;
    @media (max-width: 1800px) {
      height: 295px;
    }
    @media (max-width: 945px) {
      height: ${props => (props.modal ? '285px' : '200px')};
    }
  }

  .react-calendar__navigation__prev2-button {
    display: none;
  }
  .react-calendar__navigation {
    margin-bottom: 0;
    height: 35px;
  }
  .react-calendar__tile {
    padding: 6px 6.6667px;
  }
  .react-calendar__navigation__label {
    pointer-events: none;
  }
  .react-calendar__navigation__next2-button {
    display: none;
  }
`;
interface DayContainerProps {
  active: boolean;
}
const DayContainer = styled.div<DayContainerProps>`
  color: ${props => (props.active ? 'white' : 'black')};
  .react-calendar__month-view__days__day {
    background: gray;
  }
  .price {
    color: ${props => (props.active ? 'white' : '#6b7280')};
    font-size: 10px;
    @media (min-width: 1280px) {
      font-size: 12px;
    }
  }

  display: flex;
  flex-direction: column;
`;
interface DATEANDPAXPROPS {
  rezdyId: string;
  productId?: string;
  updateTourContext: () => void;
  mobile: boolean;
  privateTour: boolean;
  tourId: string;
  city?: string | undefined;
  name: string;
  modal?: boolean;
  detailsLoading?: boolean;
  slug?: string;
  bestReview?: {
    id: string;
    title: string;
    review: string;
    traveller: string;
    rating: number;
    source: string;
    date: string;
    created_at: string;
  };
}

const DateAndPax = ({
  bestReview,
  rezdyId,
  updateTourContext,
  mobile,
  privateTour,
  tourId,
  city,
  slug,
  name,
  modal,
  detailsLoading,
  productId
}: DATEANDPAXPROPS) => {
  const [mobileCalendar, setMobileCalendar] = useState<boolean>(false);
  const router = useRouter();
  const getTourPrice = (): { label: string; price: string | undefined }[] => {
    const priceEntry = selectedTimeSlot?.boatnew_products_prices?.find(
      entry => entry?.currency === currency
    );

    if (!priceEntry || !priceEntry?.prices) {
      return [{ label: '1 Passenger', price: undefined }];
    }

    const priceKeys = Object.keys(priceEntry?.prices);

    if (privateTour) {
      const label = priceKeys[0];
      const price = priceEntry?.prices[label];
      return [{ label, price }];
    }

    const labels = ['adult', 'child', 'infant'];
    return labels
      ?.filter(label => priceKeys?.includes(label))
      ?.map(label => ({
        label: label?.charAt(0)?.toUpperCase() + label?.slice(1),
        price: priceEntry?.prices[label]
      }));
  };

  //@ts-expect-error
  const { updatePax, updateUser, updateBestReview, currency } =
    useContext(PaxContext);
  const { data } = useQuery<FETCH_PRODUCT_BOAT_INTERFACE>(FETCH_PRODUCT_BOAT, {
    variables: {
      id: tourId
    }
  });
  const [loading, setLoading] = useState<boolean>(true);
  /* const { data, loading: dataLoading } = useQuery<FETCH_PRODUCT_BOAT_INTERFACE>(
    FETCH_PRODUCT_BOAT,
    {
      variables: {
        id: tourId
      }
    }
  ); */
  const [reloading, setReloading] = useState<boolean>(false);
  const [noAvailability, setNoAvailability] = useState<boolean>(false);
  const [productAvailabities, setProductAvailabilites] = useState<
    AVAILABILITY[]
  >([
    {
      id: 1,
      startTime: '2023-04-12',
      endTime: '2023-04-12',
      allDay: false,
      seats: 10,
      seatsAvailable: 150,
      prices: [
        {
          count: 4,
          label: 'Adults',
          title: 'children',
          price: `1234.00`
        }
      ]
    }
  ]);
  const [selectedDate, setSelectedDate] = useState<string>(
    dayjs(productAvailabities[0].startTime).format('YYYY-MM-DD')
  );

  const [isOpen, setIsOpen] = useState(false);

  const [availabilityArray, setAvailabilityArray] = useState(() =>
    productAvailabities.map(item => dayjs(item.startTime).format('YYYY-MM-DD'))
  );

  const [selectedAvailaibility, setSelectedAvailability] = useState<
    AVAILABILITY[]
  >(() =>
    productAvailabities.filter(
      date => dayjs(date.startTime).format('YYYY-MM-DD') === selectedDate
    )
  );

  const [selectedTimeSlot, setSelectedTimeSlot] = useState<AVAILABILITY>({
    ...selectedAvailaibility[0],
    prices: [
      //@ts-ignore
      selectedAvailaibility[0].prices.sort((a, b) =>
        a.label.localeCompare(b.label)
      )
    ]
  });
  function formatLabel(label: string): string {
    label = label?.replace(/^(\d+)([a-zA-Z]+)$/, '$1 $2');
    label = label?.replace(/^([a-zA-Z]+)(\d+)$/, '$1 $2');
    return label?.charAt(0)?.toUpperCase() + label?.slice(1);
  }
  const [passengerPax, setPassengerPax] = useState<PASSENGERPAX>(() => {
    const tourInfo = getTourPrice();

    const adultInfo = tourInfo?.find(
      info =>
        info?.label?.toLowerCase()?.includes('adult') ||
        info?.label?.toLowerCase()?.includes('passenger') ||
        info?.label?.toLowerCase()?.includes('group')
    );
    const childInfo = tourInfo?.find(
      info => info?.label?.toLowerCase() === 'child'
    );
    const infantInfo = tourInfo?.find(
      info => info?.label?.toLowerCase() === 'infant'
    );

    return {
      adults: {
        count: selectedTimeSlot?.seatsAvailable >= 2 ? 2 : 1,
        label: adultInfo?.label ?? 'Adult',
        price: adultInfo?.price ?? 'NaN',
        title: adultInfo?.label ?? 'Adult'
      },
      children: childInfo
        ? {
            count: 0,
            label: childInfo?.label,
            price: childInfo?.price ?? 'NaN',
            title: childInfo?.label
          }
        : undefined,
      infants: infantInfo
        ? {
            count: 0,
            label: infantInfo?.label,
            price: infantInfo?.price ?? 'NaN',
            title: infantInfo?.label
          }
        : undefined,
      seats: selectedTimeSlot?.seats
    };
  });

  const [totalPrice, setTotalPrice] = useState<number>(() =>
    Number(passengerPax?.adults.price)
  );
  const [seatsFull, setSeatsFull] = useState<boolean>(false);
  useEffect(() => {
    const getDate = async () => {
      const availability = await fetchProductAvailabilities({
        rezdyId,
        privateTour,
        startDate: dayjs().format('YYYY-MM-DD'),
        tourName: name,
        cityName: city ?? '',
        slug,
        productId
      });
      if (
        !availability ||
        (availability?.length > 0 && availability[0]?.prices?.length === 0)
      ) {
        setNoAvailability(true);
        setLoading(false);
        return;
      }
      if (availability) {
        setLoading(false);
      }
      setNoAvailability(false);

      const availableDate = availability.find(a => a.seatsAvailable > 2);
      if (availableDate && !privateTour) {
        setSelectedDate(dayjs(availableDate.startTime).format('YYYY-MM-DD'));
      } else {
        setSelectedDate(dayjs(availability[0].startTime).format('YYYY-MM-DD'));
      }
      //@ts-ignore
      setProductAvailabilites(availability);
      setAvailabilityArray(() => {
        return availability.map(item =>
          dayjs(item.startTime).format('YYYY-MM-DD')
        );
      });
    };
    getDate();
  }, [rezdyId]);
  const updateAvailabity = async (startTime: Date | null) => {
    //Check if we already loaded the availability
    const exist = productAvailabities.some(
      a =>
        dayjs(a.startTime).format('YYYY-MM-DD') ===
        dayjs(startTime).add(1, 'days').format('YYYY-MM-DD')
    );
    if (exist) return;
    setReloading(true);
    const availability = await updateProductAvailabitoes({
      rezdyId,
      startDate: startTime,
      privateTour: privateTour,
      tourName: name,
      cityName: city ?? '',
      slug,
      productId
    });

    if (!availability) {
      setReloading(false);
      return;
    }
    if (availability) {
      setReloading(false);
    }
    const uniques = removeDublicates([...productAvailabities, ...availability]);
    setProductAvailabilites(uniques);
  };
  useEffect(() => {
    setAvailabilityArray(() => {
      return productAvailabities.map(item =>
        dayjs(item.startTime).format('YYYY-MM-DD')
      );
    });
  }, [productAvailabities]);

  useEffect(() => {
    setSelectedAvailability(() =>
      productAvailabities.filter(
        date => dayjs(date.startTime).format('YYYY-MM-DD') === selectedDate
      )
    );
  }, [selectedDate, productAvailabities]);

  useEffect(() => {
    const availableSlot = selectedAvailaibility.find(
      slot => slot.seatsAvailable > 2
    );

    if (availableSlot && !privateTour) {
      setSelectedTimeSlot({
        ...availableSlot,
        prices: availableSlot?.prices?.sort((a: any, b: any) =>
          a.label.localeCompare(b.label)
        )
      });
    } else {
      setSelectedTimeSlot({
        ...selectedAvailaibility[0],
        prices:
          //@ts-ignore
          selectedAvailaibility[0].prices.sort((a: any, b: any) =>
            a.label.localeCompare(b.label)
          )
      });
    }
  }, [selectedAvailaibility]);

  useEffect(() => {
    const adults =
      passengerPax.adults.count * Number(passengerPax.adults.price);
    const children = passengerPax.children
      ? passengerPax.children.count * Number(passengerPax.children.price)
      : 0;
    const infants = passengerPax.infants
      ? passengerPax.infants.count * Number(passengerPax.infants.price)
      : 0;
    if (privateTour) {
      setTotalPrice(Number(passengerPax.adults.price));
      return;
    }
    setTotalPrice(() => Number(adults + children + infants));
  }, [passengerPax]);

  useEffect(() => {
    const childrens = passengerPax.children?.count || 0;

    const infants = passengerPax.infants?.count || 0;

    const totalPax = passengerPax.adults.count + childrens + infants;
    if (data && privateTour && totalPax >= data?.product?.quantityMax) {
      setSeatsFull(true);
      return;
    }

    if (totalPax >= passengerPax?.seats) {
      setSeatsFull(true);
      return;
    }
    setSeatsFull(false);
  }, [passengerPax]);
  useEffect(() => {
    if (!selectedTimeSlot) return;

    const tourPrices = getTourPrice(); // returns array of { label, price }
    const seatsAvailable = selectedTimeSlot?.seatsAvailable;

    const isPrivate = privateTour;

    const adultInfo = tourPrices?.find(p => {
      const label = p?.label?.toLowerCase();
      return isPrivate
        ? label?.includes('passenger') || label?.includes('group')
        : label === 'adult';
    });

    const childInfo = tourPrices?.find(
      p => p?.label?.toLowerCase() === 'child'
    );
    const infantInfo = tourPrices?.find(
      p => p?.label?.toLowerCase() === 'infant'
    );

    setPassengerPax({
      adults: {
        count: isPrivate ? 1 : seatsAvailable > 1 ? 2 : 1,
        label: adultInfo?.label || (isPrivate ? 'Group' : 'Adult'),
        price: adultInfo?.price ?? 'NaN',
        title: adultInfo?.label || (isPrivate ? 'Group' : 'Adult')
      },
      children: childInfo
        ? {
            count: 0,
            label: 'Child',
            price: `${childInfo?.price ?? 0}`,
            title: childInfo?.label
          }
        : undefined,
      infants: infantInfo
        ? {
            count: 0,
            label: 'Infant',
            price: `${infantInfo?.price ?? 0}`,
            title: infantInfo?.label
          }
        : undefined,
      seats: seatsAvailable
    });
  }, [selectedTimeSlot, productAvailabities, currency]);

  const priceCheck = (date: Date): string => {
    const dateStr = dayjs(date)?.format('YYYY-MM-DD');

    if (privateTour) {
      const slot = productAvailabities?.find(
        item => dayjs(item.startTime)?.format('YYYY-MM-DD') === dateStr
      );

      const priceEntry = slot?.boatnew_products_prices?.find(
        entry => entry?.currency === currency
      );

      if (priceEntry?.prices) {
        const label = Object.keys(priceEntry?.prices)[0];
        const value = priceEntry?.prices[label];
        return value ? `$${Number(value)}` : '';
      }

      return '';
    } else {
      return passengerPax?.adults?.price
        ? `$${Number(passengerPax?.adults?.price)?.toFixed(0)}`
        : '';
    }
  };
  const isDateAvailable = (date: Date) => {
    return availabilityArray
      .slice(0, availabilityArray.length - 1)
      .includes(dayjs(date).format('YYYY-MM-DD'));
  };

  const proceedToCheckout = () => {
    updatePax({
      ...passengerPax,
      totalPrice,
      selectedTimeSlot,
      link: data?.product?.citiesProducts[0]?.city?.gmb_link?.city?.split(
        '/review'
      )[0]
    });
    updateUser({});
    updateBestReview(bestReview);
    updateTourContext();
    router.push('/checkout');
  };

  const isMobile = useMediaQuery(500);
  const handleCallClick = () => {
    if (isMobile) {
      // Mobile behavior: initiate a call
      window.location.href = 'tel:+1-888-961-6584';
    } else {
      // Web behavior: copy to clipboard and show toast
      navigator.clipboard
        .writeText('+1-888-961-6584')
        .then(() => {
          toast.success('Copied');
        })
        .catch((err: Error) => {
          console.error('Failed to copy: ', err);
        });
    }
  };
  return (
    <div
      className={`${
        mobile ? 'block' : 'hidden'
      } mmd:block h-fit flex items-center relative z-50`}
      style={{ zIndex: 1000 }}
    >
      {loading || detailsLoading ? (
        <div className="flex justify-center items-center w-full h-full flex-col">
          <div role="status">
            <svg
              aria-hidden="true"
              className="inline w-10 h-10 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600"
              viewBox="0 0 100 101"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                fill="currentColor"
              />
              <path
                d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                fill="currentFill"
              />
            </svg>
            <span className="sr-only">Loading...</span>
          </div>
          <span className="text-gray-500 mt-[20%] text-base">
            Loading tour availabilities.
          </span>
        </div>
      ) : noAvailability ? (
        <div className="flex justify-center items-center w-full h-44 flex-col">
          <p className="text-gray-400">Coming Soon</p>
        </div>
      ) : (
        <div className=" rounded-[24px] border border-[#E0E0E0] lg:max-h-[80vh] lg:overflow-y-auto  pt-4  mx-auto w-full flex flex-col gap-2 relative  ">
          <div className="px-4">
            <div className="flex items-center justify-between w-full mb-2">
              <div className="flex items-center">
                <span className="text-[#101010] text-[24px] xl:text-[32px] font-extrabold leading-none">
                  ${Number(passengerPax.adults.price).toFixed(2)}
                </span>
              </div>
              <CurrencySwitcherToggle />
            </div>

            <div className="flex flex-col gap-2 w-full">
              <span className="text-[#1F2C5B] text-[15px] font-semibold">
                Select Date
              </span>
              <div
                onClick={(e: any) => {
                  e.stopPropagation();
                  setMobileCalendar(!mobileCalendar);
                }}
                className="bg-[#F7F8FB] rounded-full border border-[#E0E0E0] w-full px-4 py-3 flex items-center justify-between cursor-pointer"
              >
                <span className="text-primary text-base font-medium">
                  {selectedDate}
                </span>
                <div className={`transition-transform absolute right-8`}>
                  <Image
                    src="/calendar.svg"
                    width={24}
                    height={24}
                    alt="calendar"
                  />
                </div>
              </div>
              {mobileCalendar && (
                <div className="relative mt-2">
                  <StyledCelendar
                    // @ts-ignore
                    modal={modal}
                    tileContent={({ date }) => (
                      <DayContainer
                        active={
                          selectedDate === dayjs(date).format('YYYY-MM-DD')
                        }
                      >
                        {isDateAvailable(date) && (
                          <p className="text-sm text-blue-400 price">
                            {priceCheck(date)}
                          </p>
                        )}
                      </DayContainer>
                    )}
                    tileDisabled={({ date }) => !isDateAvailable(date)}
                    minDate={new Date()}
                    showNeighboringMonth={false}
                    onClickDay={value => {
                      setSelectedDate(dayjs(value).format('YYYY-MM-DD'));
                      setMobileCalendar(false);
                    }}
                    onActiveStartDateChange={({ action, activeStartDate }) => {
                      if (action === 'next') updateAvailabity(activeStartDate);
                    }}
                    value={dayjs(selectedDate).toDate()}
                  />
                </div>
              )}
            </div>

            <div className="flex flex-col gap-2 w-full mt-2">
              <span className="text-[#1F2C5B] text-[15px] font-semibold">
                Slots
              </span>
              <div className="grid grid-cols-2 gap-2 xsm:gap-3 w-full">
                {removeDublicates(selectedAvailaibility).map((item: any) => {
                  const selected = item.id === selectedTimeSlot?.id;
                  return (
                    <div
                      key={item.startTime}
                      className={`px-3 xsm:px-4 py-3 bg-[#F7F8FB] rounded-full border border-[#E0E0E0] flex items-center justify-between cursor-pointer ${
                        selected ? 'border-[#1F2C5B] bg-[#E6EEFF]' : ''
                      }`}
                      onClick={() => {
                        setSelectedTimeSlot({
                          ...item,
                          prices: item.prices.sort((a: any, b: any) =>
                            a.label.localeCompare(b.label)
                          )
                        });
                      }}
                    >
                      <span className="text-[#1F2C5B] text-[16px] font-medium">
                        {dayjs(item.startTime).format('h:mm A')}
                      </span>
                      <span
                        className={`ml-2 w-5 h-5 flex items-center justify-center rounded-md ${
                          selected
                            ? 'bg-[#1F2C5B]'
                            : 'bg-white border border-[#666]'
                        }`}
                      >
                        {selected && (
                          <svg
                            width="12"
                            height="9"
                            viewBox="0 0 12 9"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M1 4.5L4.5 8L11 1"
                              stroke="white"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        )}
                      </span>
                    </div>
                  );
                })}
              </div>
            </div>

            <div className="flex flex-col gap-2 w-full mt-2">
              <span className="text-[#1F2C5B] text-[15px] font-semibold">
                Total Guests
              </span>
              <div
                className="bg-[#F7F8FB] rounded-full border border-[#E0E0E0] px-4 py-2 flex items-center justify-between cursor-pointer w-full"
                onClick={() => setIsOpen(!isOpen)}
              >
                <div className="flex items-center gap-2">
                  <Image
                    src="/guests.svg"
                    width={30}
                    height={30}
                    alt="guests"
                  />
                  <span className="text-[#1F2C5B] text-[15px] font-medium">
                    {Object.values(passengerPax)
                      ?.filter(
                        (item): item is PASSENGERINFO =>
                          typeof item === 'object' &&
                          item !== null &&
                          'label' in item &&
                          'count' in item
                      )
                      ?.map(item =>
                        item?.count > 0
                          ? `${
                              item?.label?.charAt(0)?.toUpperCase() +
                              item?.label?.slice(1)
                            } ${privateTour ? '' : `${item?.count}X`} `
                          : ''
                      )}
                  </span>
                </div>
                <span className="w-8 h-8 flex items-center justify-center">
                  <Image
                    src="/dropdown.svg"
                    width={16}
                    height={16}
                    alt="dropdown"
                  />
                </span>
              </div>

              {seatsFull && !privateTour && (
                <p className=" text-[#FF4545] font-semibold text-sm text-center">
                  {' '}
                  Maximum limit of seats reached{' '}
                </p>
              )}
              <div
                className={`relative w-full border border-[#E0E0E0] mb-2 px-1 py-2 ${
                  !isOpen ? 'hidden' : ''
                } bg-white rounded-lg shadow-md ${
                  seatsFull && !privateTour ? 'mt-0' : 'mt-2'
                } z-10`}
              >
                {!privateTour ? (
                  <>
                    <div className="grid grid-cols-4">
                      <div className="col-span-2 flex flex-col px-2">
                        <div className="flex items-center">
                          <span className="text-[#1F2C5B] text-[15px] font-medium">
                            {passengerPax?.adults?.label
                              ?.charAt(0)
                              ?.toUpperCase() +
                              passengerPax?.adults?.label?.slice(1)}
                          </span>
                          <span className="text-[#677083] text-[10px] ml-1">
                            {passengerPax?.adults?.label === 'Quantity'
                              ? '(All ages)'
                              : '(Ages 13+)'}
                          </span>
                        </div>
                        <div className="flex justify-start">
                          <div className="flex items-center">
                            <span className="text-[#FF4545] text-sm font-bold">
                              ${passengerPax?.adults?.price}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="col-span-2 grid grid-cols-3">
                        <div className="flex justify-center items-center">
                          <button
                            onClick={() => {
                              if (passengerPax.adults.count <= 1) return;
                              setPassengerPax({
                                ...passengerPax,
                                adults: {
                                  ...passengerPax.adults,
                                  count: passengerPax.adults.count - 1
                                }
                              });
                            }}
                            className="col-span-1 rounded-full w-8 h-8 bg-white border-2 text-[#1F2C5B] text-lg font-bold"
                          >
                            -
                          </button>
                        </div>
                        <div className="flex justify-center items-center">
                          <span className="col-span-1 text-center text-[#1F2C5B] text-[15px] font-medium">
                            {passengerPax.adults.count}
                          </span>
                        </div>
                        <div className="flex justify-center items-center">
                          <button
                            onClick={() => {
                              if (!seatsFull)
                                setPassengerPax({
                                  ...passengerPax,
                                  adults: {
                                    ...passengerPax.adults,
                                    count: passengerPax.adults.count + 1
                                  }
                                });
                            }}
                            className="col-span-1 rounded-full w-8 h-8 bg-white border-2 text-[#1F2C5B] text-lg font-bold"
                          >
                            +
                          </button>
                        </div>
                      </div>
                    </div>
                    {passengerPax.children &&
                      Number(passengerPax.children.price) !== 0 && (
                        <div className="grid grid-cols-4">
                          <div className="col-span-2 flex flex-col px-2">
                            <div className="flex items-center">
                              <span className="text-[#1F2C5B] text-[15px] font-medium">
                                {passengerPax?.children?.label
                                  ?.charAt(0)
                                  ?.toUpperCase() +
                                  passengerPax?.children?.label?.slice(1)}
                              </span>
                              <span className="text-[#677083] text-[10px] ml-1">
                                {passengerPax?.children?.label === 'Child' &&
                                  '(Ages 5-12)'}
                                {passengerPax?.children?.label === 'Infant' &&
                                  '(Ages 0-5)'}
                              </span>
                            </div>
                            <div className="col-span-1 flex justify-start">
                              <div className="flex items-center text-gray-500">
                                <span className="text-[#FF4545] text-sm font-bold">
                                  ${passengerPax.children.price}
                                </span>
                              </div>
                            </div>
                          </div>
                          <div className="col-span-2 grid grid-cols-3">
                            <div className="flex justify-center items-center">
                              <button
                                onClick={() => {
                                  if (
                                    passengerPax.children &&
                                    passengerPax.children.count > 0
                                  ) {
                                    setPassengerPax({
                                      ...passengerPax,
                                      children: {
                                        ...passengerPax.children,
                                        count: passengerPax.children.count - 1
                                      }
                                    });
                                  }
                                }}
                                className="col-span-1 rounded-full w-8 h-8 bg-white border-2 text-[#1F2C5B] text-lg font-bold"
                              >
                                -
                              </button>
                            </div>
                            <div className="flex justify-center items-center">
                              <span className="col-span-1 text-center text-[#1F2C5B] text-[15px] font-medium">
                                {passengerPax.children.count}
                              </span>
                            </div>
                            <div
                              onClick={() => {
                                if (passengerPax.children) {
                                  if (!seatsFull)
                                    setPassengerPax({
                                      ...passengerPax,
                                      children: {
                                        ...passengerPax.children,
                                        count: passengerPax.children.count + 1
                                      }
                                    });
                                }
                              }}
                              className="flex justify-center items-center"
                            >
                              <button className="col-span-1 rounded-full w-8 h-8 bg-white border-2 text-[#1F2C5B] text-lg font-bold">
                                +
                              </button>
                            </div>
                          </div>
                        </div>
                      )}
                    {passengerPax.infants &&
                      Number(passengerPax.infants.price) !== 0 && (
                        <div className="grid grid-cols-4">
                          <div className="col-span-2 flex flex-col px-2">
                            <div className="flex items-center">
                              <span className="text-[#1F2C5B] text-[15px] font-medium">
                                {passengerPax.infants.label
                                  .charAt(0)
                                  .toUpperCase() +
                                  passengerPax.infants.label.slice(1)}
                              </span>
                              <span className="text-[#677083] text-[10px] ml-1">
                                {passengerPax.infants.label === 'Child' &&
                                  '(Ages 5-12)'}
                                {passengerPax.infants.label === 'Infant' &&
                                  '(Ages 0-5)'}
                              </span>
                            </div>
                            <div className="col-span-1 flex justify-start">
                              <div className="flex items-center">
                                <span className="text-[#FF4545] text-sm font-bold">
                                  ${passengerPax.infants.price}
                                </span>
                              </div>
                            </div>
                          </div>
                          <div className="col-span-2 grid grid-cols-3">
                            <div className="flex justify-center items-center">
                              <button
                                onClick={() => {
                                  if (
                                    passengerPax.infants &&
                                    passengerPax.infants.count > 0
                                  ) {
                                    setPassengerPax({
                                      ...passengerPax,
                                      infants: {
                                        ...passengerPax.infants,
                                        count: passengerPax.infants.count - 1
                                      }
                                    });
                                  }
                                }}
                                className="col-span-1 rounded-full w-8 h-8 bg-white border-2 text-[#1F2C5B] text-lg font-bold"
                              >
                                -
                              </button>
                            </div>
                            <div className="flex justify-center items-center">
                              <span className="col-span-1 text-center text-[#1F2C5B] text-[15px] font-medium">
                                {passengerPax.infants.count}
                              </span>
                            </div>
                            <div className="flex justify-center items-center">
                              <button
                                onClick={() => {
                                  if (!seatsFull)
                                    if (passengerPax.infants) {
                                      setPassengerPax({
                                        ...passengerPax,
                                        infants: {
                                          ...passengerPax.infants,
                                          count: passengerPax.infants.count + 1
                                        }
                                      });
                                    }
                                }}
                                className="col-span-1 rounded-full w-8 h-8 bg-white border-2 text-[#1F2C5B] text-lg font-bold"
                              >
                                +
                              </button>
                            </div>
                          </div>
                        </div>
                      )}
                  </>
                ) : (
                  <div>
                    {privateTour
                      ? Object.entries(
                          selectedTimeSlot?.boatnew_products_prices?.find(
                            entry => entry?.currency === currency
                          )?.prices || {}
                        )?.map(([label, price]) => (
                          <p
                            key={label}
                            className="text-black py-2 border-[1px] border-gray-100 px-4 cursor-pointer hover:bg-gray-100"
                            onClick={() => {
                              setPassengerPax({
                                ...passengerPax,
                                adults: {
                                  count: label.match(/\d+/)
                                    ? parseInt(label.match(/\d+/)![0])
                                    : 1,
                                  label: formatLabel(label),
                                  price,
                                  title: formatLabel(label)
                                }
                              });
                              setIsOpen(false);
                            }}
                          >
                            {formatLabel(label)}:{' '}
                            <span className="font-semibold">
                              ${Number(price)?.toFixed(2)} {currency}
                            </span>
                          </p>
                        ))
                      : selectedTimeSlot?.prices?.map(item => {
                          if (!item?.label) return null;

                          return (
                            <p
                              key={item?.label}
                              className="text-black py-2 border-[1px] border-gray-100 px-4 cursor-pointer hover:bg-gray-100"
                              onClick={() => {
                                setPassengerPax({
                                  ...passengerPax,
                                  adults: {
                                    count: Number(item?.label?.[0]),
                                    label: formatLabel(item?.label),
                                    price: item?.price,
                                    title: formatLabel(item?.label)
                                  }
                                });
                                setIsOpen(false);
                              }}
                            >
                              {formatLabel(item?.label)} :{' '}
                              <span className=" font-semibold ">
                                ${Number(item?.price)?.toFixed(2)}
                              </span>
                            </p>
                          );
                        })}
                  </div>
                )}
              </div>
              <p className="pl-2 text-xs text-[#677083]">
                Prices shown in {currency}
              </p>
            </div>

            <button
              className="w-full rounded-full bg-[#1F2C5B] text-white mt-2 text-[17px] font-semibold py-3"
              onClick={() => proceedToCheckout()}
            >
              Book Now $
              {privateTour ? passengerPax.adults.price : totalPrice.toFixed(2)}
            </button>
            <div className="flex flex-col gap-2.5 mt-2 ">
              <p className="text-[#677083] md:text-[16px] text-[14px] font-medium">
                Fast and easy online booking
              </p>
              <p className="text-[#677083] md:text-[16px] text-[14px] font-medium">
                Free cancellation up to 24 hours in advance
              </p>
            </div>
          </div>
          <div className="w-full min-h-[50px] h-[50px] flex items-center justify-center bg-[#F7F8FB] border-t border-[#E0E0E0] rounded-b-[23px] px-5 gap-3 z-20">
            <Image
              src="/blue-phone-icon.svg"
              width={24}
              height={24}
              alt="phone"
            />
            <span className="text-[#101010] text-[16px] font-medium">
              Call To Book
            </span>
            <a
              href="tel:1-888-961-6584"
              className="text-[#3B71FE] text-[16px] font-medium underline ml-3"
            >
              1-888-961-6584
            </a>
          </div>
        </div>
      )}
    </div>
  );
};

export default DateAndPax;
